var map = {
	"./centimeter.png": "75f5",
	"./dots.png": "a294",
	"./lumi_accessories.png": "82bf",
	"./marita_huurinainen.png": "e601",
	"./pure_waste.png": "aab9",
	"./tauko_design.png": "daad"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dcb9";